// store/index.js
import { createStore } from "vuex";
import authModule from './modules/auth';
import sharedModule from './modules/shared';
import sseModule from './modules/sse';

const store = createStore({
    modules: {
        auth: authModule,
        shared: sharedModule,
        sse: sseModule,
    },
});

export default store;
